import { IconName, Button } from '@optimus-web/core';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';

interface ExpandCollapseAllProps {
    isAllCollapsed: boolean;
    collapseAll(): void;
    expandAll(): void;
}

export const ExpandCollapseAll: React.FC<ExpandCollapseAllProps> = ({ isAllCollapsed, collapseAll, expandAll }) => (
    <Button
        variant="ghost"
        icon={isAllCollapsed ? IconName.ExpandAll : IconName.CollapseAll}
        onClick={isAllCollapsed ? expandAll : collapseAll}
        type="submit"
    >
        <LocalizedText textKey={isAllCollapsed ? TextKey.ExpandAllBills : TextKey.CollapseAllBills} />
    </Button>
);
